import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class CompanyLocationMetaModel extends FormMetaModel {
    constructor() {
      super('', ROUTE_PATH.internshipCompanyLocation, '', 3);
    }
  
    override initProperties(): any {
      const formInfo = super.initProperties();
      const companyName = new SmMetaInputModel(
        'companyName',
        'companyName',
        'input',
        false,
        'col-12 col-md-4',
        1,
        1,
        'Comapny Name',
        'text',
        '',
        true,
        true,
        true,
        false,
        100,
        1
      );
      const locName = new SmMetaInputModel(
        'locName',
        'locName',
        'input',
        false,
        'col-12 col-md-4',
        1,
        2,
        'Location Name',
        'text',
        '',
        true,
        true,
        true,
        false,
        100,
        1
      );
      const internRequired = new SmMetaInputModel(
        'internRequired',
        'internRequired',
        'input',
        false,
        'col-12 col-md-4',
        1,
        3,
        'Interns Required',
        'number',
        '',
        false,
        true,
        true,
        false,
        3,
        1
      );
      const locAddress = new SmMetaInputModel(
        'locAddress',
        'locAddress',
        'input',
        true,
        'col-12 col-md-12',
        1,
        4,
        'Location Address',
        'text',
        '',
        false,
        true,
        true,
        false,
        250,
        1
      );
      const buttons = {
        submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
        isFormControl: false,
      };
      return {
        formInfo,
        buttons,
        companyName,
        internRequired,
        locAddress,
        locName,
      };
    }
  }


  export class LocationPayload
{
  internshipCompanyId:any ='';
   id?:any ='';
  locName: any = '';
  internRequired: any = '';
  locAddress: any = '';
}
  